import React from 'react';
import activitiesPostTopics from './activitiesPostTopics';
import Activity from './Activity';
import ActivityPostCard from './ActivityPostCard';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import { useGetUser } from '../user/useAllUsers';
import omitNonTopics from '../utils/omitNonTopics';
import Link from '../utils/router/Link';
import userPath from '../utils/url/userPath';

const ACTIVITY_THANKED_POST_ACTIVITY_FRAGMENT = gql(`
  fragment ActivityThankedPost_activity on ThankedPostActivity {
    actedAt
    actor {
      ...useGetUser_user
    }
    thankedPost {
      id
      topics {
        ...activitiesPostTopics_topics
      }
      owner {
        name
        ...userPath_user
      }
      ...ActivityPostCard_post
    }
  }
`);

interface ActivityThankedPostProps {
  activity: DocumentType<typeof ACTIVITY_THANKED_POST_ACTIVITY_FRAGMENT>;
}

const ActivityThankedPost = ({ activity }: ActivityThankedPostProps) => {
  const { actedAt, thankedPost } = activity;

  const getUser = useGetUser();

  if (!activity.actor) {
    return null;
  }

  const actor = getUser(activity.actor);

  return (
    <Activity
      actor={actor}
      actedAt={actedAt}
      action="POST_THANK"
      title={
        <>
          <Link to={userPath(actor)}>{actor?.name}</Link> thanked
          {thankedPost?.owner && (
            <>
              {' '}
              <Link to={userPath(thankedPost?.owner)}>
                {thankedPost?.owner?.name}
              </Link>{' '}
              for
            </>
          )}{' '}
          a post
        </>
      }
      meta={activitiesPostTopics(
        thankedPost ? omitNonTopics(thankedPost.topics) : null,
      )}
    >
      {thankedPost ? (
        <ActivityPostCard post={thankedPost} maxLines={4} />
      ) : null}
    </Activity>
  );
};

export default ActivityThankedPost;
